import * as type from '../../../actions/index.types'

const initialState = {
    loading: false,
    glAccountsData: null,
    error: null
};

export function GLAccountReducer(state = initialState, action) {
    switch (action.type) {
        case type.GET_GL_ACCOUNTS:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_GL_ACCOUNTS_SUCCESS:
            return {
                ...state,
                loading: false,
                glAccountsData: action.payload,
                error: null,
            }
        case type.GET_GL_ACCOUNTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.message || 'Something went wrong.',
            }
        default:
            return state
    }
}
